/**
 * Popups singleton module
 */

var Popups = (function($) {

  function initPopups() {
    // do something
    $('.post-content-gallery__wrapper').magnificPopup({
        delegate: '.post-content-gallery__link', 
        type: 'image',
        verticalFit: true,
        titleSrc: 'title', 
        gallery:{
            enabled:true
        },
        removalDelay: 0,
        mainClass: 'mfp-fade',
        zoom: {
            enabled: false,
        }
      });
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.post-content-gallery__wrapper').length) {
      return;
    }

    
    initPopups();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Popups.init);
